import { FaStar } from "react-icons/fa";
import styles from "./AwardPage.module.css";
import { FaUserGroup } from "react-icons/fa6";


const SponsorsPage = () => {
    return (
        <div>
            <main className={styles.mainContent}>
                <div className={styles.comingSoonCard}>
                    <div className={styles.iconContainer}>
                        <FaUserGroup className={styles.trophyIcon} />

                        <FaStar className={`${styles.starIcon} ${styles.starOne}`} />
                        <FaStar className={`${styles.starIcon} ${styles.starTwo}`} />
                        <FaStar className={`${styles.starIcon} ${styles.starThree}`} />
                    </div>

                    <h1 className={styles.title}>
                        Sponsor
                    </h1>

                    <p className={styles.subtitle}>
                        Sponsor details will be
                        launching soon. Stay tuned!
                    </p>

                    <div className={styles.badge}>
                        Coming Soon 2026
                    </div>
                </div>

            </main>
        </div>
    )
};

export default SponsorsPage;